var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "owners-data-wrapper" },
    [
      _c("div", { staticClass: "owner-details-percent-wrapper" }, [
        _c("div", { staticClass: "ownerItem fluid" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("p", { attrs: { id: "elPOwnerFullName" } }, [
            _vm._v(
              _vm._s(_vm.customerData.firstName) +
                " " +
                _vm._s(_vm.customerData.lastName)
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "percent-controller-wrapper fluid" },
          [
            _c("v-text-field", {
              directives: [
                {
                  name: "mask",
                  rawName: "v-mask",
                  value: "###",
                  expression: "'###'"
                }
              ],
              staticClass: "percent",
              attrs: {
                dense: "",
                filled: "",
                rounded: "",
                "validate-on-blur": "",
                autocomplete: "null",
                inputmode: "numeric",
                id: "percentOwned",
                suffix: "%",
                "hide-details": ""
              },
              on: {
                blur: _vm.handleRawPercentBlur,
                focus: function($event) {
                  return _vm.updatePercentState("text")
                },
                change: function($event) {
                  return _vm.checkForAllowedOwners()
                }
              },
              model: {
                value: _vm.pSlider,
                callback: function($$v) {
                  _vm.pSlider = $$v
                },
                expression: "pSlider"
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "fluid",
                staticStyle: {
                  display: "flex",
                  "flex-direction": "column",
                  gap: "16px"
                }
              },
              [
                _c("p", { staticClass: "ownership-slider-title" }, [
                  _vm._v("Ownership Percentage ")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.pSlider,
                      expression: "pSlider"
                    }
                  ],
                  staticClass: "percentSlider",
                  attrs: {
                    type: "range",
                    min: "0",
                    max: "100",
                    step: "1",
                    id: "myRange"
                  },
                  domProps: { value: _vm.pSlider },
                  on: {
                    focus: function($event) {
                      return _vm.updatePercentState("slider")
                    },
                    change: function($event) {
                      return _vm.checkForAllowedOwners()
                    },
                    __r: function($event) {
                      _vm.pSlider = $event.target.value
                    }
                  }
                })
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "additional-owners-control-wrapper" },
        _vm._l(_vm.customerData.businessOwners, function(owner, idx) {
          return _c(
            "div",
            {
              key: owner.firstName + JSON.stringify(idx),
              staticClass: "ownerItem relative -helper--flex column",
              attrs: { id: "ownerDetails_" + idx }
            },
            [
              _c(
                "div",
                { staticClass: "-helper--flex align-center space-between" },
                [
                  _c("h4", [_vm._v("Owner #" + _vm._s(idx + 2))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "-helper--flex align-center" }, [
                    _vm.shouldAllowEdit(owner)
                      ? _c("img", {
                          staticStyle: {
                            "margin-right": "10px",
                            cursor: "pointer"
                          },
                          attrs: {
                            id: "addUbo",
                            width: "14px",
                            src: require("../../../RF_assets/icons/edit-gray-v2.svg")
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleAddOwner(owner.externalId)
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("img", {
                      staticStyle: { cursor: "pointer" },
                      attrs: {
                        id: "removeUbo",
                        width: "14px",
                        src: require("../../../RF_assets/icons/trashcan-gray.svg")
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleDeleteOwner(owner.externalId, idx)
                        }
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("p", [
                _vm._v(_vm._s(owner.firstName) + " " + _vm._s(owner.lastName)),
                _c("span", { staticStyle: { "margin-left": "12px" } }, [
                  _vm._v(
                    _vm._s(
                      owner.ownershipPercent
                        ? "(" + owner.ownershipPercent + "%)"
                        : ""
                    )
                  )
                ])
              ])
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "add-another-owner-wrapper" },
        [
          _vm.isAllowAddOwner
            ? _c(
                "button",
                {
                  staticClass: "add-owner-cta",
                  attrs: { type: "button" },
                  on: { click: _vm.handleAddOwner }
                },
                [_vm._v("+ Add another owner")]
              )
            : _vm._e(),
          _vm._v(" "),
          !this.customerData.businessOwners.length
            ? _c("BtnCheckbox", {
                staticClass: "only-ubo",
                attrs: { id: "only-ubo", txt: "I am the only UBO" },
                model: {
                  value: _vm.flags.isOnlyUbo,
                  callback: function($$v) {
                    _vm.$set(_vm.flags, "isOnlyUbo", $$v)
                  },
                  expression: "flags.isOnlyUbo"
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      this.customerData.businessOwners.length
        ? _c("v-checkbox", {
            staticClass: "owner-decleration",
            attrs: {
              rules: _vm.rules.checkbox,
              label: "",
              color: "#0078A7",
              value: "#0078A7",
              id: "owner-decleration"
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function() {
                    return [
                      _c("p", { staticClass: "check-disclaimer" }, [
                        _vm._v(
                          "\n        I hereby certify that the beneficial owner list contains all owners of\n        the business who own "
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c("b", [_vm._v(" 25% or more ")]),
                        _vm._v(" interest\n      ")
                      ])
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1440525749
            ),
            model: {
              value: _vm.flags.isChecked,
              callback: function($$v) {
                _vm.$set(_vm.flags, "isChecked", $$v)
              },
              expression: "flags.isChecked"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "-helper--flex align-center space-between" },
      [
        _c("h4", [_vm._v("Owner #1")]),
        _vm._v(" "),
        _c("div", { staticClass: "-helper--flex align-center" })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a96d434c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a96d434c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/PartnerOnboarding/business-sections/BusinessOwners.vue
// module id = null
// module chunks = 